export default {"src":"/_next/static/image/public/images/instore_orders.ed224fe753d5444bb0e4376baf8bc8d6.svg","height":29,"width":28};